import { Component, inject, viewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs';
import { PageNames } from 'src/app/configs/page-names.enum';
import { EventTypes } from 'src/app/core/constants/event-types';
import { cloneDeepObj } from 'src/app/core/utils/util';
import { BaseIndexModule } from '../../shared/base';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { ContactsComponent } from '../contacts/contacts.component';
import {
  CustomField,
  PhonebookDto,
  PhonebookTypes,
} from './../../../core//api/models';
import {
  ContactsService,
  PhonebooksService,
} from './../../../core/api/services';
import { PhonebookAdvanceSearchComponent } from './phonebook-advance-search/phonebook-advance-search.component';
import { PhonebookCustomFieldsFormComponent } from './phonebook-custom-fields-form/phonebook-custom-fields-form.component';
import { PhonebookListComponent } from './phonebook-list/phonebook-list.component';
import { PhonebookCustomDto } from './shared/phonebook-custom.model';

@Component({
  selector: 'app-phonebook',
  templateUrl: './phonebook.component.html',
  styleUrls: [
    './phonebook.component.scss',
    '../../shared/base/components/base-tree-table-page.components.scss',
  ],
  imports: [
    BaseIndexModule,
    PhonebookListComponent,
    PhonebookAdvanceSearchComponent,
    ContactsComponent,
    PhonebookCustomFieldsFormComponent,
  ],
})
export class PhonebookComponent extends BaseIndexPageComponent {
  //#region Properties
  pageName = PageNames.phonebook;
  protected currentService = inject(PhonebooksService);
  deleteApiMethodName: string = this.currentService.phonebooksDelete.name;
  createGetApiMethodName: string = this.currentService.phonebooksCreateGet.name;
  auditApiMethodName: string =
    this.currentService.phonebooksGetPhonebooksAuditWithPagination.name;
  readonly contactsComponent = viewChild(ContactsComponent);
  readonly PhonebookAdvanceSearchComponent = viewChild(
    PhonebookAdvanceSearchComponent
  );
  readonly PhonebookListComponent = viewChild(PhonebookListComponent);
  pageId: string = 'phonebook';
  isShowDynamicTemplate: boolean = false;
  get PhonebookTypes() {
    return PhonebookTypes;
  }
  eventType = EventTypes.facility;
  isUseSeparator: boolean = true;
  phonebookCustomFields: CustomField[] = [];
  selectedPhonebookId: number;
  selectedPhonebook: PhonebookDto = { id: 0 };
  isHidePhonebook: boolean = false;
  isShowContactAudit: boolean = false;
  isShowPhonebookAudit: boolean = false;
  isShowPhonebookHelp: boolean = false;
  isShowCustomFields: boolean = false;
  isShowAdvanceSearch: boolean = false;
  justCurrentOrganization: boolean = true;
  phonebookRecipients: PhonebookCustomDto[] = [];
  //#endregion

  ngOnInit(): void {}

  constructor(
    public contactsService: ContactsService,
    protected translate: TranslateService
  ) {
    super();
  }

  configTableColumns(): void {}
  getPaginationApi(): Observable<any> {
    return null;
  }

  changeAdvanceSearch(event) {
    const PhonebookListComponentValue = this.PhonebookListComponent();
    PhonebookListComponentValue.phonebookRecipients = [];
    PhonebookListComponentValue.selectedPhonebooks = [];
    const PhonebookAdvanceSearchComponentValue =
      this.PhonebookAdvanceSearchComponent();
    PhonebookAdvanceSearchComponentValue.phonebookRecipients = [];
    PhonebookAdvanceSearchComponentValue.selectedPhonebooks = [];
    PhonebookListComponentValue.changePhonebookRecipients();
    PhonebookAdvanceSearchComponentValue.changePhonebookRecipients();
    this.isShowAdvanceSearch = event;
  }

  onPhonebookRecipientsChange(event) {
    this.phonebookRecipients = event;
    this.PhonebookListComponent().selectedPhonebooks = cloneDeepObj(event);
  }

  setSelectedPhonebookFromAdvancedSearch(event) {
    if (this.isShowAdvanceSearch) this.selectedPhonebook = event;
  }

  onReloadAdvanceSearch() {
    const PhonebookAdvanceSearchComponentValue =
      this.PhonebookAdvanceSearchComponent();
    PhonebookAdvanceSearchComponentValue.phonebookRecipients =
      this.PhonebookListComponent().phonebookRecipients;
    PhonebookAdvanceSearchComponentValue.selectedPhonebooks =
      this.PhonebookListComponent().selectedPhonebooks;
    PhonebookAdvanceSearchComponentValue.getTableData();
  }

}
